import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  selectedLang = signal(localStorage.getItem('lang') || 'en');

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang(this.selectedLang());
    this.translate.use(this.selectedLang());
  }

  setLanguage(lang: string) {
    this.selectedLang.set(lang);
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
  }
}
